import { Component, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmTabsImports } from '@spartan-ng/helm/tabs';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { CaractéristiqueStore } from '../../../référentiel-métier/référentiel-métier-périmètre/perimetre-caracteristiques/store/caractéristique.store';
import { DetailCompagnonnageComponent } from './detail-compagnonnage/detail-compagnonnage.component';
import { DetailGeneralComponent } from './detail-general/detail-general.component';
import { DetailMetierComponent } from './detail-metier/detail-metier.component';
import { DetailSciencesCultureComponent } from './detail-sciences-culture/detail-sciences-culture.component';
import { JalonDetailFormService } from './jalon-detail-form.service';
import { Référentiel } from '../../../administration/gestion-référentiels/models/référentiel.model';

@Component({
  selector: 'app-jalon-detail-contenu',
  imports: [
    DetailMetierComponent,
    DetailGeneralComponent,
    DetailCompagnonnageComponent,
    DetailSciencesCultureComponent,
    HlmTabsImports,
    ReactiveFormsModule,
  ],
  templateUrl: './jalon-detail-contenu.component.html',
})
export class JalonDetailContenuComponent implements OnInit {
  readonly detailFormService = inject(JalonDetailFormService);
  readonly #caractéristiqueStore = inject(CaractéristiqueStore);
  readonly #destroyRef = inject(DestroyRef);

  readonly referentiel = input.required<Référentiel>();
  readonly peutModifier = input.required<boolean>();

  form = this.detailFormService.form;

  constructor() {
    effect(() => this.#caractéristiqueStore.charger(this.referentiel().id));

    effect(() => {
      if (!this.peutModifier()) {
        this.form.disable({ emitEvent: false });
      } else {
        this.form.enable({ emitEvent: false });
      }
    });
  }

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.#destroyRef), debounceTime(1000))
      .subscribe(() => this.detailFormService.submit());
  }
}
